__turbopack_context__.v({
  "backLink": "AiInterviewProcess-module__-ScVeq__backLink",
  "body": "AiInterviewProcess-module__-ScVeq__body",
  "copy": "AiInterviewProcess-module__-ScVeq__copy",
  "rail": "AiInterviewProcess-module__-ScVeq__rail",
  "railInner": "AiInterviewProcess-module__-ScVeq__railInner",
});
